/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { CompanyagreementContext, useCompanyagreementContext } from './companyagreement-context'
import type * as Fetcher from './companyagreement-fetcher'
import { companyagreementFetch } from './companyagreement-fetcher'
import type * as Schemas from './companyagreement-schemas'

export type ConfigurationGetHeaders = {
  /**
   * The user id of the logged in user
   */
  ['X-User']?: string
}

export type ConfigurationGetError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type ConfigurationGetVariables = {
  headers?: ConfigurationGetHeaders
} & CompanyagreementContext['fetcherOptions']

/**
 * Returns the configuration
 */
export const fetchConfigurationGet = (variables: ConfigurationGetVariables, signal?: AbortSignal) =>
  companyagreementFetch<Schemas.ApiConfiguration, ConfigurationGetError, undefined, ConfigurationGetHeaders, {}, {}>({
    url: '/',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the configuration
 */
export const useConfigurationGet = <TData = Schemas.ApiConfiguration>(
  variables: ConfigurationGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ApiConfiguration, ConfigurationGetError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCompanyagreementContext(options)
  return reactQuery.useQuery<Schemas.ApiConfiguration, ConfigurationGetError, TData>({
    queryKey: queryKeyFn({
      path: '/',
      operationId: 'configurationGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchConfigurationGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ProposalListQueryParams = {
  /**
   * Position of the first element to return
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  pagingOffset?: number
  /**
   * Maximum number of rows to return
   *
   * @format int32
   * @default 20
   * @minimum 1
   */
  pagingLimit?: number
  /**
   * The status of the proposals.
   */
  status?: Schemas.ProposalStatus
  /**
   * The name of the company
   */
  companyName?: string
  /**
   * The category of the product
   */
  productCategory?: string
}

export type ProposalListHeaders = {
  /**
   * The user id of the logged in user
   */
  ['X-User']?: string
  /**
   * The email of the user submitting the proposal
   */
  ['X-Email']?: string
}

export type ProposalListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type ProposalListVariables = {
  headers?: ProposalListHeaders
  queryParams?: ProposalListQueryParams
} & CompanyagreementContext['fetcherOptions']

/**
 * Returns the list of the proposals
 */
export const fetchProposalList = (variables: ProposalListVariables, signal?: AbortSignal) =>
  companyagreementFetch<
    Schemas.ProposalPaginated,
    ProposalListError,
    undefined,
    ProposalListHeaders,
    ProposalListQueryParams,
    {}
  >({ url: '/proposals', method: 'get', ...variables, signal })

/**
 * Returns the list of the proposals
 */
export const useProposalList = <TData = Schemas.ProposalPaginated>(
  variables: ProposalListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProposalPaginated, ProposalListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCompanyagreementContext(options)
  return reactQuery.useQuery<Schemas.ProposalPaginated, ProposalListError, TData>({
    queryKey: queryKeyFn({
      path: '/proposals',
      operationId: 'proposalList',
      variables,
    }),
    queryFn: ({ signal }) => fetchProposalList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ProposalCreateHeaders = {
  /**
   * The user id of the logged in user
   */
  ['X-User']?: string
  /**
   * The email of the user submitting the proposal
   */
  ['X-Email']?: string
  /**
   * The campaign ID of the user submitting the proposal
   */
  ['X-CampaignID']?: string
}

export type ProposalCreateError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type ProposalCreateVariables = {
  body: Schemas.ProposalBase
  headers?: ProposalCreateHeaders
} & CompanyagreementContext['fetcherOptions']

/**
 * New company agreement proposal
 */
export const fetchProposalCreate = (variables: ProposalCreateVariables, signal?: AbortSignal) =>
  companyagreementFetch<Schemas.Proposal, ProposalCreateError, Schemas.ProposalBase, ProposalCreateHeaders, {}, {}>({
    url: '/proposals',
    method: 'post',
    ...variables,
    signal,
  })

/**
 * New company agreement proposal
 */
export const useProposalCreate = (
  options?: Omit<reactQuery.UseMutationOptions<Schemas.Proposal, ProposalCreateError, ProposalCreateVariables>, 'mutationFn'>,
) => {
  const { fetcherOptions } = useCompanyagreementContext()
  return reactQuery.useMutation<Schemas.Proposal, ProposalCreateError, ProposalCreateVariables>({
    mutationFn: (variables: ProposalCreateVariables) => fetchProposalCreate({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type CategoryListQueryParams = {
  /**
   * Position of the first element to return
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  pagingOffset?: number
  /**
   * Maximum number of rows to return
   *
   * @format int32
   * @default 20
   * @minimum 1
   */
  pagingLimit?: number
  /**
   * The catalog to use
   *
   * @default welfare
   */
  catalog?: 'welfare' | 'discount'
  name?: string
  parentCategoryId?: string
  serviceCategory?: 'welfareArt100' | 'welfareArt51' | 'none'
  /**
   * If true, the children of the category are included in the response
   */
  includeChildren?: boolean
}

export type CategoryListHeaders = {
  /**
   * The user id of the logged in user
   */
  ['X-User']?: string
  /**
   * The welfare catalog id
   */
  ['X-WelfareCatalog']?: string
  /**
   * The discount catalog id
   */
  ['X-DiscountCatalog']?: string
}

export type CategoryListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type CategoryListVariables = {
  headers?: CategoryListHeaders
  queryParams?: CategoryListQueryParams
} & CompanyagreementContext['fetcherOptions']

/**
 * Returns the list of the categories
 */
export const fetchCategoryList = (variables: CategoryListVariables, signal?: AbortSignal) =>
  companyagreementFetch<
    Schemas.CategoryPaginated,
    CategoryListError,
    undefined,
    CategoryListHeaders,
    CategoryListQueryParams,
    {}
  >({ url: '/categories', method: 'get', ...variables, signal })

/**
 * Returns the list of the categories
 */
export const useCategoryList = <TData = Schemas.CategoryPaginated>(
  variables: CategoryListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CategoryPaginated, CategoryListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCompanyagreementContext(options)
  return reactQuery.useQuery<Schemas.CategoryPaginated, CategoryListError, TData>({
    queryKey: queryKeyFn({
      path: '/categories',
      operationId: 'categoryList',
      variables,
    }),
    queryFn: ({ signal }) => fetchCategoryList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type CategoryGetPathParams = {
  /**
   * ID of the category to retrieve
   */
  categoryId: string
}

export type CategoryGetQueryParams = {
  /**
   * If true, the children of the category are included in the response
   */
  includeChildren?: boolean
}

export type CategoryGetHeaders = {
  /**
   * The user id of the logged in user
   */
  ['X-User']?: string
}

export type CategoryGetError = Fetcher.ErrorWrapper<{
  status: 404
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type CategoryGetVariables = {
  headers?: CategoryGetHeaders
  pathParams: CategoryGetPathParams
  queryParams?: CategoryGetQueryParams
} & CompanyagreementContext['fetcherOptions']

/**
 * Get a category by ID
 */
export const fetchCategoryGet = (variables: CategoryGetVariables, signal?: AbortSignal) =>
  companyagreementFetch<
    Schemas.Category,
    CategoryGetError,
    undefined,
    CategoryGetHeaders,
    CategoryGetQueryParams,
    CategoryGetPathParams
  >({ url: '/categories/{categoryId}', method: 'get', ...variables, signal })

/**
 * Get a category by ID
 */
export const useCategoryGet = <TData = Schemas.Category>(
  variables: CategoryGetVariables,
  options?: Omit<reactQuery.UseQueryOptions<Schemas.Category, CategoryGetError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCompanyagreementContext(options)
  return reactQuery.useQuery<Schemas.Category, CategoryGetError, TData>({
    queryKey: queryKeyFn({
      path: '/categories/{categoryId}',
      operationId: 'categoryGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchCategoryGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ProductListQueryParams = {
  /**
   * Position of the first element to return
   *
   * @format int32
   * @default 0
   * @minimum 0
   */
  pagingOffset?: number
  /**
   * Maximum number of rows to return
   *
   * @format int32
   * @default 20
   * @minimum 1
   */
  pagingLimit?: number
  /**
   * The catalog to use
   *
   * @default welfare
   */
  catalog?: 'welfare' | 'discount'
  /**
   * The status list of the products, comma or semicolon separated.
   */
  status?: Schemas.ProductStatus[]
  /**
   * The name of the products
   */
  name?: string
  /**
   * Fuzzy search key for product_name and description using trigram similarity
   *
   * @minLength 3
   */
  key?: string
  /**
   * The category id of the products
   */
  categoryId?: string
  /**
   * If true, the products of the subcategories are included in the response
   */
  includeSubCategories?: boolean
  /**
   * The service category of the products
   */
  serviceCategory?: 'welfareArt100' | 'welfareArt51' | 'none'
  /**
   * The longitude of the point used to search the products
   *
   * @format float
   */
  locationLongitude?: number
  /**
   * The latitude of the point used to search the products
   *
   * @format float
   */
  locationLatitude?: number
  /**
   * The radius in meters used to search the products
   *
   * @format int32
   * @default 1000
   */
  locationRadius?: number
  /**
   * If true, returns only favourite products
   */
  onlyFavourites?: boolean
  /**
   * If true, returns only favourite products, if false returns only non-favourite products, if null no filter is applied
   */
  favourites?: boolean
  /**
   * If true, returns only products with active agreements, if false returns only products without agreements, if null no filter is applied
   */
  agreements?: boolean
}

export type ProductListHeaders = {
  /**
   * The user id of the logged in user
   */
  ['X-User']?: string
  /**
   * The welfare catalog id
   */
  ['X-WelfareCatalog']?: string
  /**
   * The discount catalog id
   */
  ['X-DiscountCatalog']?: string
}

export type ProductListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type ProductListVariables = {
  headers?: ProductListHeaders
  queryParams?: ProductListQueryParams
} & CompanyagreementContext['fetcherOptions']

/**
 * Returns the list of the products
 */
export const fetchProductList = (variables: ProductListVariables, signal?: AbortSignal) =>
  companyagreementFetch<Schemas.ProductPaginated, ProductListError, undefined, ProductListHeaders, ProductListQueryParams, {}>({
    url: '/products',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the list of the products
 */
export const useProductList = <TData = Schemas.ProductPaginated>(
  variables: ProductListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProductPaginated, ProductListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCompanyagreementContext(options)
  return reactQuery.useQuery<Schemas.ProductPaginated, ProductListError, TData>({
    queryKey: queryKeyFn({
      path: '/products',
      operationId: 'productList',
      variables,
    }),
    queryFn: ({ signal }) => fetchProductList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type ProductGetPathParams = {
  /**
   * ID of the product to retrieve
   */
  productId: string
}

export type ProductGetQueryParams = {
  /**
   * If true, the variants of the product are included in the response
   */
  includeVariants?: boolean
}

export type ProductGetHeaders = {
  /**
   * The user id of the logged in user
   */
  ['X-User']?: string
  /**
   * The welfare catalog id
   */
  ['X-WelfareCatalog']?: string
  /**
   * The discount catalog id
   */
  ['X-DiscountCatalog']?: string
  /**
   * The user welfare mode
   */
  ['X-UserWelfareMode']?: 'join' | 'fruition' | 'readonly'
}

export type ProductGetError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: {
        /**
         * Error type
         */
        type: string
        /**
         * HTTP status
         */
        status: number
        /**
         * Error message
         */
        title: string
        /**
         * Unique return code
         *
         * @format int32
         */
        rc?: number
      }
    }
  | {
      status: 404
      payload: {
        /**
         * Error type
         */
        type: string
        /**
         * HTTP status
         */
        status: number
        /**
         * Error message
         */
        title: string
        /**
         * Unique return code
         *
         * @format int32
         */
        rc?: number
      }
    }
>

export type ProductGetVariables = {
  headers?: ProductGetHeaders
  pathParams: ProductGetPathParams
  queryParams?: ProductGetQueryParams
} & CompanyagreementContext['fetcherOptions']

/**
 * Get a product by ID
 */
export const fetchProductGet = (variables: ProductGetVariables, signal?: AbortSignal) =>
  companyagreementFetch<
    Schemas.Product,
    ProductGetError,
    undefined,
    ProductGetHeaders,
    ProductGetQueryParams,
    ProductGetPathParams
  >({ url: '/products/{productId}', method: 'get', ...variables, signal })

/**
 * Get a product by ID
 */
export const useProductGet = <TData = Schemas.Product>(
  variables: ProductGetVariables,
  options?: Omit<reactQuery.UseQueryOptions<Schemas.Product, ProductGetError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useCompanyagreementContext(options)
  return reactQuery.useQuery<Schemas.Product, ProductGetError, TData>({
    queryKey: queryKeyFn({
      path: '/products/{productId}',
      operationId: 'productGet',
      variables,
    }),
    queryFn: ({ signal }) => fetchProductGet({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type FavouriteToggleHeaders = {
  /**
   * The user id of the logged in user
   */
  ['X-User']?: string
  /**
   * The welfare catalog id
   */
  ['X-WelfareCatalog']?: string
  /**
   * The discount catalog id
   */
  ['X-DiscountCatalog']?: string
}

export type FavouriteToggleError = Fetcher.ErrorWrapper<
  | {
      status: 400
      payload: {
        /**
         * Error type
         */
        type: string
        /**
         * HTTP status
         */
        status: number
        /**
         * Error message
         */
        title: string
        /**
         * Unique return code
         *
         * @format int32
         */
        rc?: number
      }
    }
  | {
      status: 404
      payload: {
        /**
         * Error type
         */
        type: string
        /**
         * HTTP status
         */
        status: number
        /**
         * Error message
         */
        title: string
        /**
         * Unique return code
         *
         * @format int32
         */
        rc?: number
      }
    }
>

export type FavouriteToggleVariables = {
  body: Schemas.FavouriteToggleRequest
  headers?: FavouriteToggleHeaders
} & CompanyagreementContext['fetcherOptions']

/**
 * Toggle a product as favourite
 */
export const fetchFavouriteToggle = (variables: FavouriteToggleVariables, signal?: AbortSignal) =>
  companyagreementFetch<
    Schemas.FavouriteToggleResponse,
    FavouriteToggleError,
    Schemas.FavouriteToggleRequest,
    FavouriteToggleHeaders,
    {},
    {}
  >({ url: '/favourites/toggle', method: 'post', ...variables, signal })

/**
 * Toggle a product as favourite
 */
export const useFavouriteToggle = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.FavouriteToggleResponse, FavouriteToggleError, FavouriteToggleVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useCompanyagreementContext()
  return reactQuery.useMutation<Schemas.FavouriteToggleResponse, FavouriteToggleError, FavouriteToggleVariables>({
    mutationFn: (variables: FavouriteToggleVariables) => fetchFavouriteToggle({ ...fetcherOptions, ...variables }),
    ...options,
  })
}

export type QueryOperation =
  | {
      path: '/'
      operationId: 'configurationGet'
      variables: ConfigurationGetVariables
    }
  | {
      path: '/proposals'
      operationId: 'proposalList'
      variables: ProposalListVariables
    }
  | {
      path: '/categories'
      operationId: 'categoryList'
      variables: CategoryListVariables
    }
  | {
      path: '/categories/{categoryId}'
      operationId: 'categoryGet'
      variables: CategoryGetVariables
    }
  | {
      path: '/products'
      operationId: 'productList'
      variables: ProductListVariables
    }
  | {
      path: '/products/{productId}'
      operationId: 'productGet'
      variables: ProductGetVariables
    }
